/**
 * KEY==Value for equality checks
 */
export enum NotificationTypeEnum {
  GENERAL = 'GENERAL',
  MACHINES_LONG_OFFLINE = 'MACHINES_LONG_OFFLINE',
  LICENSE_EXPIRATION = 'LICENSE_EXPIRATION',
  DEADLINE = 'DEADLINE',
  EVENT = 'EVENT',
}
